import React from 'react';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { compose } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { VEHICLE_TABS_TYPES, AUCTION_STATUSES } from '../../../../constants';
import { getBidsCounters, isBidsCountersLoaded, getBidAuctionStatus } from '../../../../selectors/bids';

const NotFoundDescription = ({ loading, currentFilter, countersLoaded, counters }) => {
  const isFilterEmpty = !Object.keys(currentFilter).length;
  const dataLoaded = isFilterEmpty && !loading && countersLoaded;

  if (!dataLoaded) return null;

  let text = null;
  const { [VEHICLE_TABS_TYPES.ACTIVE]: inProgressBids, [VEHICLE_TABS_TYPES.PENDING]: pendingBids, auction } = counters;
  const isAuctionActive = auction && auction.status === AUCTION_STATUSES.ACTIVE;
  const isAuctionEnded = auction && auction.status === AUCTION_STATUSES.ENDED;
  const isInProgressBids = Boolean(inProgressBids);
  const isPendingBids = Boolean(pendingBids);

  const noBidsActiveAuction = !isInProgressBids && !isPendingBids && isAuctionActive;
  const noBidsEndedAuction = !isInProgressBids && !isPendingBids && isAuctionEnded;

  if (noBidsActiveAuction) {
    text = (
      <>
        You have not bid on any vehicles. Please visit our
        {' '}
        <Link to='/'>auction</Link>
        {' '}
        to view vehicles and place bids.
      </>
    );
  } else if (noBidsEndedAuction) { 
    text = (
      <>
        The auction has ended. When our next auction begins, you can view vehicles and place bids on our 
        {' '}
        <Link to='/'>auction</Link>
        {' '}
        page.
      </>
    );
  }

  return text;
};

const mapStateToProps = state => {
  const { auctionStatus } = state.bids;

  const currentFilter = formValueSelector(
    auctionStatus === VEHICLE_TABS_TYPES.ACTIVE
      ? 'bidsActiveFilterForm'
      : 'bidsPendingFilterForm'
  );
  return {
    auctionStatus: getBidAuctionStatus(state),
    counters: getBidsCounters(state),
    countersLoaded: isBidsCountersLoaded(state),
    loading: state.bids.loading,
    currentFilter: currentFilter(state, 'status', 'user_id')
  };
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
  ),
)(NotFoundDescription);
